export const Types = {
  number: 'number',
  text: 'text',
  date: 'date',
  undefined: 'undefined',
  numberWithCommas: 'numberWithCommas',
  twoDecimalsWithPercent: 'twoDecimalsWithPercent',
};
